import { resolveSlug } from "@/lib/resolveSlug";

const EMPTY_SCOPE = "__no_slug__";

export function storageScopeSlug(slug?: string | null): string {
  return slug || resolveSlug().slug || EMPTY_SCOPE;
}

export function scopedStorageKey(baseKey: string, slug?: string | null): string {
  return `${baseKey}:${encodeURIComponent(storageScopeSlug(slug))}`;
}
